import React, { use, useEffect, useRef, useState } from "react";
import { icons, images } from "../Data";

const menu = [
  {
    items: [
      {
        title: "Language | English",
        icon: icons.language,
        submenu: [
          {
            secTitle: "Select Language",
            text: "You agree that English is the authoritative version and would assume any risk in reliance on the translation.",
            radioText1: "English",
            radioText2: "Español",
            buttonText: "Save",
          },
        ],
      },
    ],
  },
  {
    items: [{ title: "Walmart+", icon: icons.walmart }],
  },
  {
    items: [
      { title: "Purchase History", icon: icons.history },
      { title: "My Items", icon: icons.cart },
      { title: "Account", icon: icons.user },
    ],
  },
  {
    items: [{ title: "Help", icon: icons.help }],
  },
  {
    items: [
      { title: "Lists", icon: icons.lists },
      { title: "Registries", icon: icons.lists },
    ],
  },
  {
    items: [
      {
        title: "Departments",
        icon: icons.departments,

        submenu: [
          {
            secTitle: "Departments",
            items: [
              { title: "Electronics" },
              { title: "Home" },
              { title: "Grocery" },
              {
                title: "Fashion",
                submenu: [
                  {
                    secTitle: "Fashion",
                    items: [
                      { title: "Men" },
                      { title: "Women" },
                      { title: "Kids" },
                      { title: "Accessories" },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: "Services",
        icon: icons.services,

        submenu: [
          {
            secTitle: "Services",
            icon: icons.feedback,

            items: [
              { title: "Pharmacy" },
              { title: "Auto Care Center" },
              { title: "Money Services" },
            ],
          },
        ],
      },
    ],
  },
  {
    items: [{ title: "Give Feedback", icon: icons.feedback }],
  },
];

const MobileMenu = ({ menu, path, setPath, level = 0 }) => {
  const currentIndex = path[level];

  return (
    <>
      <div
        onClick={(e) => e.stopPropagation()}
        className="absolute shadow-lg border border-black bg-white h-full left-0 w-full flex flex-col"
      >
        <div className="px-4">
          {level === 0 ? (
            <div className="flex items-center gap-4 mt-8 link">
              <img src={images.sparkicon} className="max-w-[30px]" alt="" />
              <span className="font-semibold bg-[#0053E2] px-2 py-1 text-sm rounded-full text-white">
                Sign in or create account
              </span>
            </div>
          ) : (
            <div
              onClick={() => {
                setPath((prev) => {
                  const newPath = { ...prev };
                  delete newPath[level];
                  newPath[level - 1].child = null;
                  return newPath;
                });
              }}
              className="flex items-center border-b py-4 cursor-pointer gap-1 text-[#6f6f6f]"
            >
              <span className="rotate-90 text-2xl">{icons.downarrow}</span>
              <span className="font-semibold text-lg">Back to main menu</span>
            </div>
          )}
        </div>

        {menu.map((m, i) => {
          return (
            <div key={i} className="px-4">
              {m.secTitle !== "" && i === 0 && (
                <>
                  <div className="font-bold text-lg border-b py-4">
                    {m?.secTitle}
                  </div>
                  {path[0]?.parent === 0 && path[0]?.child === 0 && (
                    <div className="flex flex-col gap-6">
                      <div className="text-[.6rem] text-[#656565] py-4">
                        {m?.text}
                      </div>

                      <div className="flex link w-fit items-center gap-4 font-bold text-sm">
                        <span className="p-2 relative after:absolute after:inset-[2px] after:bg-black after:rounded-full rounded-full border border-black "></span>
                        <span>{m?.radioText1}</span>
                      </div>
                      <div className="flex w-fit link items-center gap-4 font-bold text-sm">
                        <span className="p-2 rounded-full border border-black"></span>
                        <span>{m?.radioText2}</span>
                      </div>
                      <span className="font-semibold link w-fit bg-[#0053E2] px-6 py-2 text-lg rounded-full text-white">
                        {m?.buttonText}
                      </span>
                    </div>
                  )}
                </>
              )}
              <div className="flex flex-col border-b py-2">
                {m?.items?.map((item, j) => {
                  return (
                    <div key={j}>
                      {item.title && (
                        <div
                          onClick={() => {
                            setPath((prev) => ({
                              ...prev,
                              [level]: { parent: i, child: j },
                            }));
                          }}
                          className="flex items-center justify-between gap-6 border-black p-2 hover:bg-gray-200 cursor-pointer"
                        >
                          <div className="flex items-center gap-2">
                            <span>{item.icon}</span>
                            <span>{item.title}</span>
                          </div>
                          <span className="rotate-[-90deg]">
                            {item?.submenu && icons.downarrow}
                          </span>
                        </div>
                      )}

                      {item.para && <div>ad</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {menu[path[level]?.parent]?.items[path[level]?.child]?.submenu && (
        <MobileMenu
          key={level}
          menu={menu[path[level].parent].items[path[level].child]?.submenu}
          level={level + 1}
          path={path}
          setPath={setPath}
        />
      )}
    </>
  );
};

const Navbar = () => {
  const [path, setPath] = useState({});

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();

  const [search, setSearch] = useState("");

  const [tabOpen, setTabOpen] = useState(false);

  useEffect(() => {
    const handleClick = (e) => {
      setMenuOpen(false);
    };
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [menuOpen]);

  return (
    <>
      {tabOpen && (
        <div
          onClick={() => setTabOpen(false)}
          className="fixed z-10 inset-0 w-screen h-screen bg-black opacity-50"
        ></div>
      )}
      <div
        ref={menuRef}
        style={{
          transform: menuOpen ? "translateX(0%)" : "translateX(-100%)",
          transition: ".5s transform ease",
        }}
        className="fixed z-20 top-0 min-w-[280px] flex bg-white min-h-screen"
      >
        <MobileMenu menu={menu} path={path} setPath={setPath} />
      </div>
      <div className="fixed w-full top-0 z-10 py-4 px-4 flex items-center gap-3 md:gap-6 bg-[#0053E2]">
        <div className="shrink-0">
          <span
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpen(!menuOpen);
            }}
            className="text-3xl link text-white md:hidden"
          >
            {icons.menu}
          </span>
        </div>
        <div className="shrink-0">
          <img
            src={images.sparkicon}
            className="max-w-[30px] md:max-w-[40px] "
            alt=""
          />
        </div>

        {/* pickup */}
        <div
          onClick={() => setTabOpen(!tabOpen)}
          className="hidden link relative xl:flex shrink-0 items-center gap-2 rounded-full bg-[#002E99] text-white px-2 py-1"
        >
          <div className=" max-w-[30px]">
            <img src={images.mobileicon} alt="" />
          </div>
          <div className="flex flex-col">
            <h2 className="font-bold text-sm">Pickup or delivery?</h2>
            <p className="text-[.7rem]">
              Sacramento, 95829 • Sacramento Supercenter...
            </p>
          </div>
          <span className={`${tabOpen ? "rotate-180" : ""}`}>
            {icons.downarrow}
          </span>

          {tabOpen && (
            <div className="absolute rounded-lg text-sm min-w-[360px] top-full left-1/2 -translate-x-1/2 w-full p-6 bg-[#0053E2]">
              <div className="flex link mt-8 mb-2 items-center justify-center text-[.75rem] gap-4">
                <div className="flex flex-col gap-3 items-center justify-center">
                  <div className="max-w-[50px]">
                    <img src={images.icon1} alt="" />
                  </div>
                  <div className="font-bold">Shipping</div>
                </div>
                <div className="flex flex-col gap-3 items-center justify-center">
                  <div className="max-w-[50px]">
                    <img src={images.icon2} alt="" />
                  </div>
                  <div className="font-bold">Pickup</div>
                </div>
                <div className="flex flex-col gap-3 items-center justify-center">
                  <div className="max-w-[50px]">
                    <img src={images.icon3} alt="" />
                  </div>
                  <div className="font-bold">Delivery</div>
                </div>
              </div>
              <div className="bg-white text-black rounded-lg p-4">
                <div className="flex gap-2">
                  <span className="text-[#656565]">{icons.map}</span>
                  <div className="flex flex-col gap-2 text-[.7rem]">
                    <p className="font-bold leading-none">
                      Add an address for shipping and delivery
                    </p>
                    <p className="leading-none text-[#656565]">
                      Sacramento, CA 95829
                    </p>
                  </div>
                </div>
                <div className="bg-[#0053E2] link mt-3 text-[.8rem] text-center text-white font-bold rounded-full p-1.5">
                  Add address
                </div>
              </div>
              <div className="flex link items-center justify-between bg-white mt-2 text-black rounded-lg p-4">
                <div className="flex gap-2">
                  <span className="text-[#656565]">{icons.home}</span>
                  <div className="flex flex-col gap-2 text-[.7rem]">
                    <p className="font-bold leading-none">
                      Sacramento Supercenter
                    </p>
                    <p className="leading-none text-[#656565]">
                      8915 GERBER ROAD, Sacramento, CA 95829
                    </p>
                  </div>
                </div>
                <div className="-rotate-90 text-2xl">{icons.downarrow}</div>
              </div>
            </div>
          )}
        </div>

        <div
          className="flex-1 bg-white px-4 py-[2px] rounded-full overflow-hidden flex items-center 
  focus-within:ring-2 focus-within:ring-black  focus-within:ring-offset-[-5px] focus-within:ring-offset-white
  bg-clip-padding"
        >
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full h-12 rounded-full pr-2"
            placeholder="Search everything at Walmart online and in store"
          />
          <div className="flex items-center gap-4 md:text-2xl">
            <span
              onClick={() => setSearch("")}
              className={`cursor-pointer  ${search === "" && "hidden"}`}
            >
              {icons.cross}
            </span>
            <span className="bg-[#002E99] cursor-pointer rounded-full p-1 text-white">
              {icons.search}
            </span>
          </div>
        </div>
        <div className="hidden md:flex cursor-pointer items-center gap-2 text-sm text-white">
          <span>{icons.heart}</span>
          <div className="flex flex-col">
            <p>Reorder</p>
            <p className="font-bold">My Items</p>
          </div>
        </div>
        <div className="hidden md:flex cursor-pointer items-center gap-2 text-sm text-white">
          <span>{icons.user}</span>
          <div className="flex flex-col">
            <p>Sign in</p>
            <p className="font-bold">Account</p>
          </div>
        </div>
        <div className="flex cursor-pointer flex-col items-center text-sm text-white">
          <span className="text-2xl relative after:absolute after:content-['12'] after:text-[.7rem] after:w-5 after:h-5 after:flex after:items-center after:justify-center after:top-[-10px] after:right-[-10px] after:bg-[#FFC220] after:text-black after:rounded-full after:p-[2px]">
            {icons.cart}
          </span>
          <p className="">$208.98</p>
        </div>
      </div>
    </>
  );
};

export default Navbar;
